import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const SelectedInvoicesRoutes = createFeatureRoutes(
  'selected-invoices',
  {
    list: () => import('../presentation/pages/SelectedInvoicesPage'),
    details: () => import('../presentation/pages/SelectedInvoicesDetails'),
    paymentPreview: () => import('../presentation/pages/PaymentPreviewPage'),
    paymentConfirmation: () => import('../presentation/pages/PaymentConfirmationPage'),
    invoice: () => import('@/home/presentation/pages/InvoiceDetails'),
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'details', pageKey: 'details' },
    { path: 'payment-preview', pageKey: 'paymentPreview' },
    { path: 'payment-confirmation/:id?', pageKey: 'paymentConfirmation' },
    { path: ':id', pageKey: 'details' },
    { path: 'invoice/:id', pageKey: 'invoice' },
  ],
);

export default SelectedInvoicesRoutes;
